let sound_effect = new Audio();
let audioPromise = null;

let repsound = null;

function type_select(type) {
  switch (type) {
    case "alert":
      sound_effect.src = "../media/alert.wav";
      break;
    case "arm":
      sound_effect.src = "../media/arm.wav";
      break;
    case "disarm":
      sound_effect.src = "../media/disarm.wav";
      break;
    default:
      break;
  }
}

function play(type, freq, timeout) {
  type_select(type);
  if (sound_effect.src) {
    stop();
    setTimeout(function () {
      if (timeout) {
        setTimeout(function () {
          stop();
        }, timeout);
      }
    }, 200);
  }
}

function stop() {
  if (audioPromise) {
    audioPromise.then(function () {
      sound_effect.pause();
    });
  }

  clearInterval(repsound);
}

export default {
  play: play,
  stop: stop,
};
